import { FormattedMessage } from 'react-intl';
import { ChargingOptions } from '../ChargingOptions/ChargingOptions';
import { commonSectionClassName } from '../SettingsOptions/SettingsOptions';
import { RouteConstraints } from './RouteConstraints';
import { RouteCosts } from './RouteCosts';
import { RouteDeparture } from './RouteDeparture';

export const RouteOptions = () => (
    <div className='RouteOptions display-flex flex-column gap-25 margin-top-10' data-testid='route-options'>
        <div className={commonSectionClassName}>
            <div className='display-flex align-items-center justify-content-between'>
                <FormattedMessage id='intl-msg:smartRoute.tour.departure' />
            </div>
            <hr className='margin-top-5 margin-bottom-10' />
            <RouteDeparture />
        </div>

        <div className={commonSectionClassName}>
            <div className='display-flex align-items-center justify-content-between'>
                <FormattedMessage id='intl-msg:smartRoute.tour.restrictions' />
            </div>
            <hr className='margin-top-5 margin-bottom-20' />
            <RouteConstraints />
        </div>

        <div className={commonSectionClassName}>
            <div className='display-flex align-items-center justify-content-between'>
                <FormattedMessage id='intl-msg:smartRoute.generic.costs' />
            </div>
            <hr className='margin-top-5 margin-bottom-10' />
            <RouteCosts />
        </div>

        <div className={commonSectionClassName}>
            <div className='display-flex align-items-center justify-content-between'>
                <FormattedMessage id='intl-msg:smartRoute.generic.charging' />
            </div>
            <hr className='margin-top-5 margin-bottom-10' />
            <ChargingOptions />
        </div>
    </div>
);
